import { Fragment } from 'react'
import { cn } from '#app/utils/misc.tsx'

type AccentedTextProps = {
	/**
	 * Plain text with `*accent*` markers. Each marker pair renders its contents
	 * in architectural gold. Use for inline accents in headlines and ledes,
	 * e.g. "hybrid *(B2B2C)* custom manufacturers*.*"
	 */
	text?: string | null
	className?: string
}

const ACCENT_RE = /(\*[^*]+\*)/g

export function AccentedText({ text, className }: AccentedTextProps) {
	if (!text) return null
	const parts = text.split(ACCENT_RE).filter(Boolean)

	return (
		<span className={className}>
			{parts.map((part, i) => {
				if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
					return (
						<span key={i} className="text-gold">
							{part.slice(1, -1)}
						</span>
					)
				}
				return <Fragment key={i}>{part}</Fragment>
			})}
		</span>
	)
}
